// extracted by mini-css-extract-plugin
export default {"report-builder-table":"ReportBuilderTable_report-builder-table__g1y5k","loading":"ReportBuilderTable_loading__WKe3P"};